module.exports = __webpack_public_path__ + "media/lucas.db3c532e.wav";